import logoPic from 'assets/img/logo.png';
import logoPic_02 from 'assets/img/logo_02.png';
const logo = logoPic;
const logo_02 = logoPic_02;
const logoName = '呗呗';
const systemName = '成都互联分享管理系统';
const slogan = '让医生学习更简单';
const vision = '8.2.2';
const tel = '4007-028-333';

export const config = {
	logo: logo,
	logo_02: logo_02,
	logoName: logoName,
	systemName: systemName,
	slogan: slogan,
	vision: vision,
	tel: tel
}


// WEBPACK FOOTER //
// ./src/views/layout/config/config.js